// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3ZlvP","info":"UpdateTermsInfo_info__1ZlQE"};